import { type SVGProps } from "react";

import { cn } from "@/shared/helpers/cn.helper";

interface CancelSmallIconProps extends SVGProps<SVGSVGElement> {
  className?: string;
}

export const CancelSmallIcon = ({ className, ...props }: CancelSmallIconProps) => (
  <svg
    className={cn("text-light-400", className)}
    fill="none"
    height="24"
    viewBox="0 0 24 24"
    width="24"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M7.39494 16.6051L12 12M16.6051 7.39491L12 12M12 12L7.39494 7.39491M12 12L16.6051 16.6051"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
    />
  </svg>
);

export default CancelSmallIcon;
